export default __webpack_public_path__ + "static/media/BB_38.608183b2.png";